module.exports = __webpack_public_path__ + "img/MenuBarButtonLogo.771c9fa0.svg";